import { api, IEnumAdminPermissionKeys } from '@chess-class/sandbox';

export function checkEditPermission(access: IEnumAdminPermissionKeys): boolean {
  const me = api.user.adminAuth.useAdminMe();

  return me.data?.accesses[access] == 'EDIT';
}
